import { Pipe, PipeTransform } from '@angular/core';
import { conformToMask } from 'text-mask-core';
import { PhoneMaskService } from '../services/phone-mask.service';

@Pipe({
  name: 'phoneNumber',
  standalone: false
})
export class PhoneNumberPipe implements PipeTransform {
  constructor(private readonly _phoneMaskService: PhoneMaskService) {}

  transform(phone: string): any {
    return phone ? conformToMask(phone, this._phoneMaskService.getPhoneRegex(), { guide: false }).conformedValue : '';
  }
}
